<template>
  <!-- Begin Page Content -->
  <div class="container">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Зар баталгаажуулах</h1>
    </div>
    

    <div class="row my-5">
      <div class="col col-12 my-3" v-for="(item, index) in items">
        <div class="card">
          <div class="card-body">
            <p  class="font-weight-bold text-dark text-lg" v-if="item.shortCategory">
              <span v-if="item.shortCategory.category">{{item.shortCategory.category}}</span>
              <span v-if="item.shortCategory.type">/{{item.shortCategory.type}}</span>
              <span v-if="item.shortCategory.subtype">/{{item.shortCategory.subtype}}</span>

            </p>
            <div class="d-flex ">
              <img style="border-radius:5%;height:160px;" v-if="_getImage(item)" :src="_getImage(item)" alt="">
              <div class="mx-3  flex-fill ">
                <p class="font-weight-bold">{{index+1}}. {{item.name}}</p>

                <p  class="" v-if="item.shortCarType">
                  <span v-if="item.shortCarType.cartype">{{item.shortCarType.cartype}}</span>
                  <span v-if="item.shortCarType.carmark">/{{item.shortCarType.carmark}}</span>
                  <span v-if="item.shortCarType.aral">/{{item.shortCarType.aral}}</span>
                  <span v-if="item.shortCarType.caryear">/{{item.shortCarType.caryear}}</span>
                  <span v-if="item.shortCarType.carmodel">/{{item.shortCarType.carmodel}}</span>

                </p>
                <div class="row  justify-content-between">
                  <div class="col col-md-6 col-sm-12">
                    <div v-if="item.storeData">
                      <span  class="text-primary font-weight-bold"  v-if="item.storeData.name">{{item.storeData.name}}</span>
                      <br/>
                      <p  class="" v-if="item.storeData.shortAddress">
                        <span v-if="item.storeData.shortAddress.city">{{item.storeData.shortAddress.city}}</span>
                        <span v-if="item.storeData.shortAddress.district">/{{item.storeData.shortAddress.district}}</span>
                        <span v-if="item.storeData.shortAddress.horoo">/{{item.storeData.shortAddress.horoo}}</span>
                        <span v-if="item.storeData.address">/{{item.storeData.address}}</span>

                      </p>
                      
                      
                    </div>
                  </div>
                  <div  class="col col-md-6 col-sm-12">
                    <div  style="text-align:end">
                      <span class="badge badge-success" v-if="item.mount==true">Суурилуулалттай</span>
                      <span  class="badge badge-danger" v-else>Суурилуулалтгүй</span>
                    </div>
                    <div  style="text-align:end">
                      <span class="badge badge-success" v-if="item.shipping==true">Хүргэлттэй</span>
                      <span  class="badge badge-danger" v-else>Хүргэлтгүй</span>
                    </div>
                  </div>
                  
                </div>
              </div>

            </div>
            <div class="row justify-content-center">
              <button class="mx-3 btn btn-success btn-sm" @click="approve(item, index)">Зөвшөөрөх</button>
              <button class="mx-3 btn btn-danger btn-sm" @click="deleteItem(item, index)">Устгах</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col" v-if="end!=true">
        <button @click.prevent="getItems" class="btn btn-success btn-sm btn-block">Цааш нь үзэх</button>
      </div>
    </div>

    <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
            <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-success" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-danger" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-warning" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-info" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-dark" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require('../../firebaseConfig.js');
import Vue from 'vue';
import { mapState } from 'vuex';
import firebase from 'firebase';
import 'firebase/firestore';
export default {
  name: "CheckItems",
  data() {
    return {
      parent:null,
      categories:[],
      items:[],
      firstVisible:null,
      lastVisible:null,
      end:false,
      loading:false

    };
  },
  methods: {
    getCategories(){
      this.getItems();
    },
    async getItems(){
 

        if(this.end!=true){
          var querySnapshot;
          var first=false;
          if(this.lastVisible==null){
            var query=fb.db.collectionGroup("selbeg")
            query=query.where("active", "==", false).where("approved", "==", false).orderBy("createdAt", "asc").limit(30);
            querySnapshot=await query
            .get();
            if(querySnapshot!=null && !querySnapshot.empty){
              this.firstVisible=querySnapshot.docs[0];
              first=true;
            }
          }
          else{
            var query=fb.db.collectionGroup("selbeg")
            query=query.where("active", "==", false).where("approved", "==", false).orderBy("createdAt", "asc")
            .startAfter(this.lastVisible)
            .limit(30);
            querySnapshot=await query.get();
          }
          
          if(querySnapshot!=null && !querySnapshot.empty){

            if(first==true || ( first!=null && this.firstVisible.id!=null && this.firstVisible.id!=querySnapshot.docs[0].id)){
              // console.log("abc");
              for(const itemDoc of querySnapshot.docs){
                let item=itemDoc.data();
                item.id=itemDoc.id;
                item.storeData=null;
                item.path=itemDoc.ref.path;
                if(item.store){
                  item.store.get().then(storeDoc=>{
                    if(storeDoc && storeDoc.exists){
                      item.storeData=storeDoc.data();
                    }
                  })
                }
                // console.log(item);
                this.items.push(item);
              }
              this.lastVisible=querySnapshot.docs[querySnapshot.docs.length-1];
            }
            else
              this.end=true;
            
          }
        }
      
    },
    getCategoryItems(categoryId){
      this.items=[];
      this.firstVisible=null;
      this.lastVisible=null;
      this.end=false;
      this.getItems();
    },
    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {

        return obj.images[0]["fileUrl"];
      }
      return null;
    },
    async approve(item, index){
      var r = confirm("Та энэ зарыг нээлттэй болгох уу?");
      if (r == true) {
        if(item && item.id && item.path){
          this.loading=true;
          var batch=fb.db.batch();
          batch.update(
            fb.db.doc(item.path),
            {
              "active": true,
              "approved": true,
              "approvedAt": new Date()
            }
          );

          if(item.store){
            batch.update(
              item.store,
              {
                "numberOfItems": fb.firestore.FieldValue.increment(1)
              }
            );
            if(item.category){
              var tmpDoc=await item.store.collection("categorycount").doc(item.category.id).get();
              if(tmpDoc&& tmpDoc.exists){
                batch.update(
                  tmpDoc.ref,
                  {
                    "count": fb.firestore.FieldValue.increment(1)
                  }
                );
              }
              else{
                tmpDoc.reference.setData({"category": item.category,  "count": FieldValue.increment(1),  "all": FieldValue.increment(1)});
                batch.set(
                  tmpDoc.ref,
                  {
                    "count": fb.firestore.FieldValue.increment(1),
                    "all": fb.firestore.FieldValue.increment(1),
                    category: item.category
                  }
                );
              }
            }
          }

          if(item.category){
            batch.update(
              item.category,
              {
                numberOfItems: fb.firestore.FieldValue.increment(1)
              }
            );
          }

          if(item.type){
            batch.update(
              item.type,
              {
                numberOfItems: fb.firestore.FieldValue.increment(1)
              }
            );
          }

          if(item.subtype){
            batch.update(
              item.subtype,
              {
                numberOfItems: fb.firestore.FieldValue.increment(1)
              }
            );
          }
          
          await batch.commit();
          this.items.splice(index, 1);
          this.loading=false;
        }
      }
      
    },
    deleteItem(item, index){
      var r = confirm("Та энэ зарыг устгах уу?");
      if (r == true) {
        this.loading=true;
        var addMessage = firebase.functions().httpsCallable('deleteAdByAdmin');
        addMessage({ itemPath: item.path })
          .then((result) => {
          this.items.splice(index, 1);
          this.loading=false;
        });
      }

    }
  },
  created(){
    this.getCategories();
  }
};
</script>

